import { LoginState } from './login.types'

const initialState: LoginState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
